import * as React from "react";
import PropTypes from "prop-types";
import "./MethodSplitImage.scss";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const MethodSplitImage = (props) => {
  const image = getImage(props.image);
  const isBoxed = props.isBoxed;
  const horizontal = props.orientation ? " method-split-image-horizontal" : "";
  return (
    <div className={"method-split-image-container" + horizontal}>
      <div className="method-split-image-left" />
      <div
        className={`method-split-image ${isBoxed ? "container-fluid" : null}`}
      >
        <GatsbyImage
          imgStyle={isBoxed ? { width: "100%" } : {}}
          image={image}
          alt=""
        />
      </div>
      <div className="method-split-image-right" />
    </div>
  );
};

MethodSplitImage.propTypes = {
  image: PropTypes.string.isRequired,
  isBoxed: PropTypes.bool,
  orientation: PropTypes.string,
};

export default MethodSplitImage;
